import { render, staticRenderFns } from "./DetailsData.vue?vue&type=template&id=7b8ec28e&scoped=true&"
import script from "./DetailsData.vue?vue&type=script&lang=js&"
export * from "./DetailsData.vue?vue&type=script&lang=js&"
import style0 from "./DetailsData.vue?vue&type=style&index=0&id=7b8ec28e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8ec28e",
  null
  
)

export default component.exports